import type { I18nOptions } from 'vue-i18n';

const datetimeFormats: I18nOptions['datetimeFormats'] = {
	en: {
		shortFormat: {
			day: 'numeric',
			month: 'numeric',
		},
		dayMonth: {
			day: 'numeric',
			month: 'long',
			calendar: 'gregory'
		},
		// «8 октября» — ближайшая дата без года: следующее начисление резерва
		dayMonth: {
			day: 'numeric',
			month: 'long',
		},
		defaultFormat: {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric'
		},
		longFormat: {
			day: 'numeric',
			month: 'long',
			year: 'numeric'
		},
	},
	ru: {
		shortFormat: {
			day: 'numeric',
			month: 'numeric',
		},
		dayMonth: {
			day: 'numeric',
			month: 'long',
			calendar: 'gregory'
		},
		defaultFormat: {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
			calendar: 'gregory'
		},
		longFormat: {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
			calendar: 'gregory'
		}
	},
	kz: {
		shortFormat: {
			day: 'numeric',
			month: 'numeric',
		},
		dayMonth: {
			day: 'numeric',
			month: 'long',
			calendar: 'gregory'
		},
		defaultFormat: {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
			calendar: 'gregory'
		},
		longFormat: {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
			calendar: 'gregory'
		}
	},
	pl: {
		shortFormat: {
			day: 'numeric',
			month: 'numeric',
		},
		dayMonth: {
			day: 'numeric',
			month: 'long',
			calendar: 'gregory'
		},
		defaultFormat: {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
			calendar: 'gregory'
		},
		longFormat: {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
			calendar: 'gregory'
		}
	},
	es: {
		shortFormat: {
			day: 'numeric',
			month: 'numeric',
		},
		dayMonth: {
			day: 'numeric',
			month: 'long',
			calendar: 'gregory'
		},
		defaultFormat: {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
			calendar: 'gregory'
		},
		longFormat: {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
			calendar: 'gregory'
		}
	}
}

export default datetimeFormats;
